import React, { useState } from 'react';
import CarTypesTab from '@/components/admin/tabs/CarTypesTab';
import { useCars } from '@/hooks/useCars';

/**
 * Car Types Management Component
 * Wrapper for CarTypesTab with all required state management
 */
export const CarTypesManagement = ({ API }) => {
  const {
    cars,
    carTypes,
    createCarType,
    updateCarType,
    deleteCarType
  } = useCars(API);

  const [showCarTypeDialog, setShowCarTypeDialog] = useState(false);
  const [editingCarType, setEditingCarType] = useState(null);
  const [carTypeForm, setCarTypeForm] = useState({
    name: '',
    description: '',
    base_daily_rate: '',
    features: ''
  });

  const resetCarTypeForm = () => {
    setCarTypeForm({
      name: '',
      description: '',
      base_daily_rate: '',
      features: ''
    });
    setEditingCarType(null);
  };

  const handleCreateCarType = async (e) => {
    e.preventDefault();
    await createCarType(carTypeForm);
    setShowCarTypeDialog(false);
    resetCarTypeForm();
  };

  const handleUpdateCarType = async (e) => {
    e.preventDefault();
    await updateCarType(editingCarType, carTypeForm);
    setShowCarTypeDialog(false);
    resetCarTypeForm();
  };

  const openEditCarType = (carType) => {
    setEditingCarType(carType.id);
    setCarTypeForm({
      name: carType.name,
      description: carType.description,
      base_daily_rate: carType.base_daily_rate,
      features: carType.features ? carType.features.join(', ') : ''
    });
    setShowCarTypeDialog(true);
  };

  const handleDeleteCarType = async (carTypeId) => {
    if (!window.confirm('Are you sure you want to delete this car type?')) return;
    await deleteCarType(carTypeId);
  };

  return (
    <CarTypesTab
      carTypes={carTypes}
      cars={cars}
      showCarTypeDialog={showCarTypeDialog}
      setShowCarTypeDialog={setShowCarTypeDialog}
      editingCarType={editingCarType}
      setEditingCarType={setEditingCarType}
      carTypeForm={carTypeForm}
      setCarTypeForm={setCarTypeForm}
      resetCarTypeForm={resetCarTypeForm}
      handleCreateCarType={handleCreateCarType}
      handleUpdateCarType={handleUpdateCarType}
      openEditCarType={openEditCarType}
      handleDeleteCarType={handleDeleteCarType}
    />
  );
};
